module.exports = __webpack_public_path__ + "img/transparent_intellij.1951ca47.png";